<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="onCancel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{ "page_settings" | translate }}</h4>
</div>

<div class="modal-body page-settings-tabs">
    <div class="tabs_wrapper">
        <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" [class.active]="isGeneralTabActive" (click)="changeActiveTab('general')">
                <a>{{ "settings_common" | translate }}</a>
            </li>
            <li role="presentation" [class.active]="isSeoTabActive" (click)="changeActiveTab('seo')">
                <a>{{ "settings_seo" | translate }}</a>
            </li>
        </ul>

        <div [hidden]="isSeoTabActive">
            <div class="form-group mb-20" [class.has-error]="name.invalid && name.dirty">
                <label class="control-label">
                    {{ "page_title" | translate }}
                </label>

                <input
                    class="form-control"
                    type="text"
                    name="pageName"
                    autofocus
                    spPageNameCheck
                    [spPageNameOptions]="{ siteId: siteId.toString(), checkIfDirty: true }"
                    [placeholder]="'page_name_default' | translate"
                    [formControl]="name"
                />

                <ng-container *ngIf="name.invalid && name.dirty; else showHint">
                    <p *ngIf="name.hasError(savePageErrorCodes.PAGE_NAME_ALREADY_USED)" class="help-block small">
                        {{ "page_name_taken" | translate }}
                    </p>
                </ng-container>

                <ng-template #showHint>
                    <p class="help-block small">
                        {{ "page_name_hint" | translate }}
                    </p>
                </ng-template>
            </div>

            <div class="form-group mb-20" [class.has-error]="url.invalid && url.dirty">
                <label class="control-label">
                    {{ "site_domain_url" | translate }}
                </label>

                <div class="input-group">
                    <div class="input-group-addon overflow-url" [tooltip]="siteDomain" tooltipPlacement="top">
                        <span>{{ siteDomain }}/</span>
                    </div>
                    <input
                        class="form-control"
                        type="text"
                        name="url"
                        spPageUrlCheck
                        [spPageUrlOptions]="{ siteId: siteId.toString(), checkIfDirty: true }"
                        [formControl]="url"
                        [tooltip]="urlTooltipText"
                    />
                </div>
                <ng-container *ngIf="url.dirty">
                    <p *ngIf="url.hasError(savePageErrorCodes.PAGE_URL_ALREADY_USED)" class="help-block small">
                        {{ "page_url_taken_error" | translate }}
                    </p>
                    <p *ngIf="url.hasError(savePageErrorCodes.PAGE_URL_INVALID)" class="help-block small">
                        {{ "page_url_invalid" | translate }}
                    </p>
                    <p *ngIf="url.hasError(savePageErrorCodes.PAGE_URL_RESERVED)" class="help-block small">
                        {{ "page_url_reserved" | translate }}
                    </p>
                </ng-container>
            </div>
        </div>

        <div [hidden]="isGeneralTabActive">
            <!---- SEO NAME --->
            <div class="form-group">
                <label>
                    {{ "page_seo_name" | translate }}
                </label>
                <input
                    class="form-control"
                    type="text"
                    name="seoName"
                    maxlength="254"
                    [placeholder]="'page_name_default' | translate"
                    [formControl]="seoName"
                />
                <p class="help-block small">
                    {{ "page_seo_name_hint" | translate }}
                </p>
            </div>

            <!---- DESCRIPTION --->
            <div class="form-group">
                <label>
                    {{ "page_seo_description" | translate }}
                </label>
                <textarea
                    class="form-control"
                    maxlength="254"
                    [placeholder]="'page_seo_description_default' | translate"
                    [formControl]="description"
                ></textarea>
                <p class="help-block small">
                    {{ "page_seo_description_hint" | translate }}
                </p>
            </div>

            <!---- KEYWORDS --->
            <div class="form-group">
                <label>
                    {{ "page_seo_keywords" | translate }}
                </label>
                <textarea
                    class="form-control"
                    maxlength="254"
                    [placeholder]="'page_seo_keywords_default' | translate"
                    [formControl]="keywords"
                ></textarea>
                <p class="help-block small">
                    {{ "page_seo_keywords_hint" | translate }}
                </p>
            </div>

            <!---- SHARED IMG --->
            <div class="form-group">
                <label>
                    {{ "page_seo_shared_img" | translate }}
                </label>
                <div class="d-flex" [class.hidden]="!!sharedImg.value">
                    <div
                        #drop
                        class="form-upload-file"
                        ngx-dropzone
                        [maxFileSize]="4000000"
                        accept="image/*"
                        (change)="setSharedImgFile($event)"
                    >
                        {{ "page_upload_img_descr_1" | translate }}
                        <br /> {{ "page_upload_img_descr_2" | translate }}
                    </div>
                    <div class="form-image-size">
                        <span class="small text-muted">
                            {{ "page_seo_shared_img_hint" | translate }}
                        </span>
                    </div>
                </div>

                <div *ngIf="sharedImg.value">
                    <div class="float-left">
                        <img
                            *ngIf="!isSharedImgFile; else showFilePreview"
                            width="120px"
                            height="auto"
                            style="max-height: 160px"
                            [src]="pageSettings.shared_img_url"
                            [alt]="pageSettings.shared_img_name"
                        />
                        <ng-template #showFilePreview>
                            <div class="shared-img-preview">
                                <ngx-dropzone-image-preview [file]="$any(sharedImg.value)"></ngx-dropzone-image-preview>
                            </div>
                        </ng-template>
                    </div>
                    <div class="float-left margin-left-10">
                        {{ sharedImgName }}<br />
                        <button class="btn btn-default btn-sm" (click)="drop.showFileSelector()">
                            {{ "page_seo_shared_img_upload_another" | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <!---- CAN BE INDEXED --->
            <div class="form-group">
                <label>
                    <input type="checkbox" [checked]="canBeIndexed.value" (change)="toogleCanBeIndexed()" />
                    {{ "page_seo_can_be_indexed" | translate }}
                    <span
                        [tooltip]="'page_seo_can_be_indexed_tooltip' | translate"
                        class="color-light sp-icon icon-info-bold small"
                    >
                    </span>
                </label>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn btn-default" type="button" (click)="onCancel()">
        {{ "cancel" | translate }}
    </button>
    <button class="btn btn-green" type="button" [class.disabled]="disableConfirm" (click)="onConfirm()">
        {{ "save" | translate }}
    </button>
</div>
